export const TIPO_PESSOA_ENUM = [
    {
        id: 'FISICA',
        descricao: "Pessoa Física"
    },
    {
        id: 'JURIDICA',
        descricao: "Pessoa Jurídica"
    },
];